import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../api/api";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
// import { X } from "lucide-react";
import OtpInput from "react-otp-input";
// import { otp_api } from "../../api/urls";
import { useSelector } from "react-redux";
import { useEffect } from "react";
// import { Reotp_url } from "../../api/urls"; // make sure this is imported
import { password_reset_api } from "../../api/urls";

const OTP = ({ setPage, setOtp, otp }) => {
  const {
    handleSubmit,
    // formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const phone = useSelector((state) => state.auth.phone);
  const [resendTimer, setResendTimer] = useState(30);
  const [isResending, setIsResending] = useState(false);

  const handleVerify = async () => {
    // ✅ Check if the OTP is less than 6 digits (invalid)
    if (otp.length < 6) {
      setOtp(""); // ❌ Set error flag to true to show red border and error message
      toast.error("Please enter a valid 6-digit OTP"); // ❌ Show a toast message for feedback
      return; // ❌ Stop further execution
    }

    // ✅ If OTP is valid, clear the error
    // setOtp("");

    // ✅ Start loading (button shows "Verifying...")
    setLoading(true);

    try {
      // 🔒 Place your OTP verification API call here
      // If successful:
      // const otp_handling = await api.post(otp_api, {
      //   token: otp,
      // });

      toast.success("OTP Verified!");
      setPage(2); //  Move to ConfirmPassword page
    } catch (error) {
      toast.error("OTP verification failed");
    } finally {
      setLoading(false); // ✅ Stop loading
    }
  };
  const handleResendOtp = async () => {
    try {
      if (!phone) {
        toast.error("Phone number not found");
        return;
      }

      setIsResending(true);

      await api.post(password_reset_api, { email: phone });

      toast.success("OTP resent successfully");
      setOtp(""); // clear previous OTP
      setResendTimer(30); // reset timer
    } catch (error) {
      toast.error("please try again in 15 minutes");
    } finally {
      setIsResending(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev === 0) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="auth-card"
    > */}
      {/* <div className="xIcon" onClick={onclose}>
        <X />
      </div> */}
      <h2 style={styles.title}>Enter OTP</h2>
      <form onSubmit={handleSubmit(handleVerify)} style={styles.form}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span></span>}
            renderInput={(props) => <input {...props} />}
            inputStyle={{
              width: "40px",
              height: "40px",
              margin: "0 5px",

              textAlign: "center",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </div>

        <motion.button
          type="submit"
          variant="contained"
          fullWidth
          disabled={loading}
          style={styles.button}
          whileHover={{ scale: 1.05 }}
        >
          {loading ? "Signing Up..." : "Verify"}
        </motion.button>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p style={{ fontSize: "12px", color: "grey" }}>
            if you didn receive a code,{" "}
            {/* <motion.span
              whileHover={{ scale: 1.05 }}
              onClick={() => setPage(2)}
              style={{
                color: "blue",
                fontWeight: "700",
                fontSize: "12px",
                cursor: "pointer",
              }}
            >
           Resend
            </motion.span> */}
            <motion.span
              whileHover={{ scale: resendTimer === 0 ? 1.05 : 1 }}
              onClick={resendTimer === 0 ? handleResendOtp : null}
              style={{
                color: resendTimer === 0 ? "blue" : "grey",
                fontWeight: "700",
                fontSize: "12px",
                cursor: resendTimer === 0 ? "pointer" : "not-allowed",
              }}
            >
              {resendTimer > 0
                ? `Resend in ${resendTimer}s`
                : isResending
                ? "Resending..."
                : "Resend"}
            </motion.span>
          </p>
        </div>

        {/* <motion.button
          type="submit"
          variant="contained"
          fullWidth
          disabled={loading}
          style={{
            ...styles.button,
            color: "black",
            backgroundColor: "white",
            border: "1px solid lightgray",
          }}
          onClick={() => setIsUnRegistered(0)}
          whileHover={{ scale: 1.05 }}
        >
          Sign-In
        </motion.button> */}
      </form>
      {/* </motion.div> */}
    </>
  );
};

const styles = {
  title: {
    textAlign: "center",
    marginBottom: "10px",
    color: "#333",
    fontSize: "24px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  errorText: {
    color: "red",
    textAlign: "center",
  },
  button: {
    background: "#000000",
    color: "#FFF",
    padding: "12px",
    fontSize: "16px",
    borderRadius: "5px",
  },
};

export default OTP;
